import React, { memo } from 'react';
import { type CellRenderContext } from '../field-read-module.ts';
import { type EntryDetailsReadContent } from './entry-details-read-content.ts';
import styles from './entry-details-value-view.module.css';

/**
 * Preserves V1's list spacing and nested value container without adding gridcells.
 */
export const EntryDetailsValueView = memo(function EntryDetailsValueView({
  content,
  context
}: {
  readonly content: EntryDetailsReadContent;
  readonly context?: CellRenderContext;
}) {
  if (!context || !content.targets.length) {
    return null;
  }

  return (
    <ul className={styles.value}>
      {content.targets.map((target, index) => (
        <li key={index}>
          <span className={styles.nested}>{context.renderNested(target)}</span>
        </li>
      ))}
    </ul>
  );
});
